export const kebabToCamel = (str) => {
  return str.replace(/-([a-z])/g, (match, letter) => letter.toUpperCase());
};

const getCurrencySymbol = (currency) =>
  currency === "USD" ? "$" : currency === "AUD" ? "AU$" : "Rp";

export const formatCurrencyLocal = (val, currency = "Rp") => {
  const num = Number(val ?? 0);
  const currencySymbol = getCurrencySymbol(currency);

  if (Number.isNaN(num)) return `${currencySymbol}${val}`;
  return `${currencySymbol}${num.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const formatNumberLocal = (val) => {
  const num = Number(val ?? 0);
  if (Number.isNaN(num)) return val;
  return num.toLocaleString("en-US");
}
